export const environment = {
  production: false,
  // apiUrl: 'http://emanager-saas-dev.supraesapp.com:8080/hr-management',
  // apiUrl: 'https://emanager-odoo-dev-be.azurewebsites.net',
  // apiUrl: 'http://20.197.41.120:8080/hr-management',
    apiUrl: 'https://emanager-odoo-b.centralindia.cloudapp.azure.com/hr-management',
};

